<template>
  <a-drawer width='45%' :label-col='4' :wrapper-col='14' :visible='open' @close='onClose'>
    <a-divider orientation='left'>
      <b>店铺开本卷包配置</b>
    </a-divider>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline'>
        <a-row :gutter='48'>
          <a-col :md='12' :sm='24'>
            <a-form-item label='店铺'>
              <a-select v-model='this.queryParam.shopId' placeholder='请选择店铺' show-search option-filter-prop="children" @change="handleChange">
                <a-select-option v-for='shop in shopList' :key='shop.shopId' :value='shop.shopId'>
                  {{ shop.shopName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24" style="float: right">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table bordered :data-source='list' :columns='columns' :loading="loading" :pagination="false">
      <template slot='shopName' slot-scope='text'>
        {{ text }}
      </template>
      <template slot='volumeCount' slot-scope='text'>
        {{ text }}
      </template>
      <template slot='volumePackageDiscount' slot-scope='text, record'>
        <editable-cell :text='text' @change="onCellChange(record.id, 'volumePackageDiscount', $event)" />
      </template>
      <template slot='couponPackPromoValidity' slot-scope='text, record'>
        <editable-cell :text='text' @change="onCellChange(record.id, 'couponPackPromoValidity', $event)" />
      </template>
      <template slot='action' slot-scope='text, record'>
        <a @click='onSave(record)' :disabled="submitLoading">
          <a-icon type="save" /> 保存
        </a>
      </template>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      :show-quick-jumper="false"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => `共 ${total} 条`"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-drawer>
</template>

<script>
import { listAllShopByScriptId, pageShopScriptV2, updateShopScript } from '@/api/played/shopScript'

const EditableCell = {
  props: {
    text: String
  },
  data() {
    return {
      value: this.text,
      editable: false
    }
  },
  methods: {
    handleChange(e) {
      const value = e.target.value
      this.value = value
    },
    check() {
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      this.editable = true
    }
  },
  render(h) {
    if (this.editable) {
      return h('div', { class: 'editable-cell' }, [
        h('div', { class: 'editable-cell-input-wrapper' }, [
          h('a-input', {
            props: { value: this.value },
            on: {
              change: this.handleChange,
              pressEnter: this.check
            }
          }),
          h('a-icon', {
            props: { type: 'check' },
            class: 'editable-cell-icon-check',
            on: { click: this.check }
          })
        ])
      ])
    } else {
      return h('div', { class: 'editable-cell' }, [
        h('div', { class: 'editable-cell-text-wrapper' }, [
          this.value || ' ',
          h('a-icon', {
            props: { type: 'edit' },
            class: 'editable-cell-icon',
            on: { click: this.edit }
          })
        ])
      ])
    }
  }
}
export default {
  components: {
    EditableCell
  },
  data() {
    return {
      shopList: [],
      submitLoading: false,
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        scriptId: null,
        shopId: null
      },
      list: [],
      open: false,
      columns: [
        {
          title: '店铺名称',
          dataIndex: 'shopName',
          scopedSlots: { customRender: 'shopName' }
        },
        {
          title: '卷包中卷的数量',
          dataIndex: 'volumeCount',
          scopedSlots: { customRender: 'volumeCount' }
        },
        {
          title: '卷包折扣',
          dataIndex: 'volumePackageDiscount',
          scopedSlots: { customRender: 'volumePackageDiscount' }
        },
        {
          title: '卷包优惠卷有效期(单位:天)',
          dataIndex: 'couponPackPromoValidity',
          scopedSlots: { customRender: 'couponPackPromoValidity' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '15%',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    /** 搜索按钮操作 */
    handleQuery () {
      this.getList()
    },
    isValidJSONArrayFlexible(str) {
      if (typeof str !== 'string') return false

      // 移除首尾空白
      const trimmed = str.trim()
      if (trimmed.length === 0) return false

      // 检查是否以[开头，]结尾
      if (!trimmed.startsWith('[') || !trimmed.endsWith(']')) return false

      // 提取内部内容
      const innerContent = trimmed.substring(1, trimmed.length - 1).trim()

      // 如果是空数组
      if (innerContent === '') return false

      // 分割内容
      const items = innerContent.split(',').map(item => item.trim())

      // 检查每个元素是否为有效数字
      for (const item of items) {
        if (item === '' || isNaN(Number(item)) || !/^\d+(\.\d+)?$/.test(item)) {
          return false
        }
      }

      return true
    },
    getList () {
      this.loading = true
      this.list = []
      pageShopScriptV2(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam.shopId = null
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = 10
      this.handleQuery()
    },
    handleChange(value) {
      this.queryParam.shopId = value
    },
    onCellChange(key, dataIndex, value) {
      console.log('onCellChange调用:', key, dataIndex, value)
      console.log('当前list:', this.list)
      // 尝试使用id查找（考虑类型转换）
      let target = this.list.find(item => item.id === key || String(item.id) === String(key)
      )
      console.log('通过id查找结果:', target)
      // 如果没找到，尝试使用shopId查找（考虑类型转换）
      if (!target) {
        target = this.list.find(item => item.shopId === key || String(item.shopId) === String(key)
        )
        console.log('通过shopId查找结果:', target)
      }
      // 如果找到了目标项，更新数据
      if (target) {
        const list = [...this.list]
        const index = list.findIndex(item => item.id === key || String(item.id) === String(key) || item.shopId === key || String(item.shopId) === String(key)
        )
        console.log('找到的索引:', index)
        if (index !== -1) {
          list[index][dataIndex] = value
          this.list = list
          console.log('更新后的list:', this.list)
        }
      } else {
        console.log('未找到目标项')
      }
    },
    onSave(record) {
      this.submitLoading = true
      if (!record.volumePackageDiscount) {
        this.$message.error(
          '卷包折扣 不能为空 正确格式参考示例[9,8.5]',
          3
        )
        this.submitLoading = false
        return
      }
      if (!this.isValidJSONArrayFlexible(record.volumePackageDiscount)) {
        this.$message.error(
          '卷包折扣 数据格式错误 正确格式参考示例[9,8.5]',
          3
        )
        this.submitLoading = false
        return
      }
      try {
        const arr1 = JSON.parse(record.volumePackageDiscount)
        const arr2 = JSON.parse(record.volumeCount)
        if (arr1.length !== arr2.length) {
          this.$message.error(
            '卷包中卷的数量 卷包折扣 匹配错误',
            3
          )
          this.submitLoading = false
          return
        }
      } catch (e) {
        console.error('JSON解析失败:', e)
      }
      updateShopScript(record).then(response => {
        this.$message.success(
          '保存成功',
          3
        )
        this.handleQuery()
      }).finally(() => {
        this.submitLoading = false
      })
    },
    handle(row) {
      this.queryParam.scriptId = row.scriptId
      listAllShopByScriptId(row.scriptId).then(response => {
        this.shopList = response.data
      })
      this.open = true
      this.resetQuery()
    },
    onClose() {
      this.open = false
    }
  }
}
</script>

<style scoped>
.editable-cell {
  position: relative;
  white-space: nowrap;
}

.editable-cell-input-wrapper {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.editable-cell-input-wrapper .ant-input {
  width: 120px;
  margin-right: 8px;
}

.editable-cell-icon-check {
  cursor: pointer;
  color: #1890ff;
}

.editable-cell-text-wrapper {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.editable-cell-icon {
  cursor: pointer;
  color: #1890ff;
  margin-left: 8px;
  font-size: 14px;
}

/* 表头样式 */
:deep(.ant-table-thead > tr > th) {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
